import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAvatarLayerEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify, confirmAndRemove } = useCrudActions();

    const model = reactive({
        id: route.params.layerId,
        name: '',
        position: 0,
        totalItemImages: null,
        canDelete: false
    });

    const validations = {
        name: { required },
        position: { required, integer, min: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = executeAction({
        request: () => avatarService.layer.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_AVATAR.LAYER.INDEX })
    });

    const actions = {
        update: excuteAndNotify({
            validator: v$,
            request: () => avatarService.layer.update(model.id, model.name, model.position),
            onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.LAYER.INDEX })
        }),
        remove: confirmAndRemove({
            request: () => avatarService.layer.remove(model.id),
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, actions };
}
